export const cardType = {
  NO_LOGIN: 'no_login',
  COMMON: 'common',
  FAMILY_SUB: 'family_sub',
};


export const sizeMap = {
  [cardType.NO_LOGIN]: {
    width: 320,
    height: 397,
  },
  [cardType.COMMON]: {
    width: 320,
    height: 484,
  },
  [cardType.FAMILY_SUB]: {
    width: 320,
    height: 292,
  },
};
